export const results = {
  '-1': {
    '-1': [
      `Morning. Added custom post types to GitLog yesterday. Users can now define their own templates instead of being stuck with my defaults. Also wired up tone selection in the UI.`,
      `Up early debugging the tone-of-voice refactor. GitLog can now generate posts in whatever style you configure. Beats hardcoding everything. Next: testing edge cases with empty configs.`,
      `Quick update: GitLog now lets you create custom post formats and tones. Took longer than expected—had to refactor the entire generation pipeline. At least users aren't locked into my writing style anymore.`,
    ],
    '-2': [
      'Spent the morning making GitLog configurable. Users can now define custom post types and tones of voice instead of being stuck with my defaults. The generation pipeline pulls from their settings.',
      'Refactored the post generation to use user-defined voice settings. No more hardcoded tone - you set your own style and the app generates accordingly. Also added CRUD for custom post types.',
      'GitLog now lets you configure your own posting style instead of using mine. Added custom post types and configurable tone settings. Generation engine reads from user prefs now 🔧',
    ],
    '-3': [
      'Custom post types and tone presets are live in GitLog. You can now define your own content templates instead of using the hardcoded defaults. Should make the generated posts less generic.',
      'Shipped user-defined tones of voice for GitLog. No more being stuck with my writing style - you can configure how commit messages get turned into posts. UI lets you pick between your saved presets.',
      'GitLog now lets you create custom post formats and tones. Refactored the generation pipeline to use user configs instead of fixed templates. Three commits to get the data flow right but it works.',
    ],
    '-4': [
      'Calling it a day. Added custom post types and tone selection to GitLog. Users can now define their own content styles instead of being stuck with defaults. Basic CRUD operations working.',
      'Signing off. Refactored the post generation pipeline to handle user-defined tones. The UI lets you pick between different voice styles now. Less rigid than the hardcoded approach.',
      'Done for today. GitLog now supports custom post types and configurable tones of voice. Users complained about the fixed formatting, so they can define their own rules now. 🔧',
    ],
    '-5': [
      'Week 3 update. Added custom post types so users can define their own content templates. Built tone selection into the UI. The generation pipeline now pulls from user-defined voice settings instead of hardcoded defaults.',
      'Spent this week making the content generation configurable. Users can now create custom post types, define their own tones, and select between them in the UI. No more hardcoded voice settings.',
      'Three features shipped: custom post type creation/editing, user-defined tone of voice system, and UI selectors for both. The generation process now runs entirely on user config instead of defaults. 🔧',
    ],
    '-6': [
      `Shipped custom post types for GitLog 🔧

• Added CRUD operations for user-defined post templates
• Refactored generation pipeline to use selected tone configs
• Built UI selectors for switching between voice presets
• Moved from hardcoded formats to dynamic user settings`,
      `Finally killed the hardcoded post templates in GitLog

• Added create/edit/delete for custom post types
• Refactored tone selection into the generation flow
• Built voice preset management in the UI
• Users can now define their own content formats`,
      `GitLog now supports custom post types instead of fixed templates

• Added full CRUD for user-defined post formats
• Refactored generation to pull from selected tone configs
• Built tone selector UI components
• Removed hardcoded voice assumptions`,
    ],
  },
  '-2': {
    '-1': [
      `Morning ☕

Working on custom post types for GitLog. People think differently about their work updates. Some want technical, others want casual. The tool should adapt to you.`,
      `Good morning.

Added tone customization to GitLog yesterday. Your commits stay the same, but now you can choose how they sound when shared. Simple idea, but it changes everything.`,
      `Morning check-in 👋

GitLog now lets you create your own post styles. Because a startup founder and an open source maintainer shouldn't sound identical when sharing progress.`,
    ],
    '-2': [
      `Spent the morning on customization.

Users can now define their own post types and tones of voice. No more being stuck with defaults.

The generation process adapts to whatever voice you choose.`,
      `Small but meaningful update.

GitLog now lets you create custom post types and define your own tone of voice for content generation.

Your commits, your voice.`,
      `Added something I've wanted for a while.

Custom post types and user-defined tones of voice. The app now generates content that actually sounds like you.

Simple change, but it makes all the difference. ✨`,
    ],
    '-3': [
      `Custom post types are live in GitLog.

You can now create your own templates instead of being stuck with the defaults. Shape your updates exactly how you want them.`,
      `Just shipped tone of voice controls.

GitLog now adapts to how you actually communicate. No more fighting with rigid templates that don't sound like you.`,
      `GitLog now lets you define your own voice.

Custom tones and post types mean your updates feel authentic to you. Simple idea, but changes everything about the output.`,
    ],
    '-4': [
      `Calling it a day.

Added custom post types and tones of voice to GitLog. Now you can shape how your commits become tweets. Simple idea, but it changes everything.`,
      `Signing off for today.

GitLog can now speak in your voice. Custom post types, personalized tones. Your commits, your style. Feels right.`,
      `That's a wrap.

Built custom tones and post types into GitLog. Same commits, infinite ways to tell the story. The tool bends to you now, not the other way around.`,
    ],
    '-5': [
      `This week on GitLog:

- Added custom post types so you can define your own formats
- Built tone of voice selection into the UI
- Users can now create their own voice presets
- Refactored generation to use custom tones

Simple tools work better when they bend to you.`,
      `Weekly progress:

- Custom post types are live
- Tone of voice system is working
- UI lets you pick between different voices
- Generation engine respects user preferences

The best software adapts to how you think, not the other way around.`,
      `Small updates this week:

- You can now create custom post formats
- Added tone selection throughout the app
- Voice presets save and load properly
- Generation feels more personal now

Good tools disappear. You just think and ship.`,
    ],
    '-6': [
      `GitLog now lets you define your own voice.

• Added custom tone creation and editing
• Built tone selector into post generation flow
• Refactored generation engine to use user-defined voices
• Updated UI to manage multiple writing styles`,
      `Been working on making GitLog more personal.

• Added custom post type creation and management
• Implemented user-defined tone of voice system
• Refactored content generation to use custom tones
• Built editing interface for post templates`,
      `GitLog gets more flexible today.

• Added ability to create and edit custom post formats
• Implemented tone of voice customization
• Refactored generation process for user-defined styles
• Updated UI to select between different voices`,
    ],
  },
}
